import { render, staticRenderFns } from "./PaymentFormFinancialInstrumentPayrix.vue?vue&type=template&id=249e2fc9&"
import script from "./PaymentFormFinancialInstrumentPayrix.vue?vue&type=script&lang=js&"
export * from "./PaymentFormFinancialInstrumentPayrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports